import React from 'react'

const CasinoListItemInt = (props: any) => {
  return (
    <>
      {props.games &&
        props.games.map((Item: any, key: number) => (
          <div
            className='casino-int-game-card'
            key={key}
            role='button'
            tabIndex={0}
            onClick={() => props.setGamePlay(Item)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                props.setGamePlay(Item)
              }
            }}
          >
            <div className='casino-int-game-card__media'>
              <img
                src={Item.game_images}
                alt=''
                className='casino-int-game-card__img'
                loading='lazy'
                decoding='async'
              />
            </div>
            <div className='casino-int-game-card__name'>
              {Item.game_name || Item.identifier || ''}
            </div>
          </div>
        ))}
    </>
  )
}
export default React.memo(CasinoListItemInt)
